import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-worlpay',
  templateUrl: './worlpay.component.html',
  styleUrls: ['./worlpay.component.css']
})
export class WorlpayComponent implements OnInit {

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      try {
        window.parent.postMessage({
          type: 'worldpayRedirect',
          data: params
        }, location.origin);
      } catch (e) {
        //this.LogErrorDetails(null, e, "Online-ReadWorldPayData", params)
      }
    });
  }

}
